<style lang="scss" scoped>
@import 'common/sass/reuse.SCSS';
</style>

<template>
  <div class="maintenance-box">
    <div :element-loading-text="loadText" class="panel" v-loading="loading">
      <custom-table
        :downloadLoading="downloadLoading"
        :downLoadTran="downLoadTran"
        :jsonExcelAjax="jsonExcelAjax"
        :name="name"
        :page="page"
        :selPage="selPage"
        :tableHead="tableHead"
        :tbodyData="tbodyData"
        @tableChange="ajaxHandle"
      ></custom-table>
    </div>
  </div>
</template>

<script>
import customTable from 'components/reuseTable'
import { URL_CLIENT_REPORT } from 'api/api'

const data = () => {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0,
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10,
    },
  }
}

const mixins = [require('common/mixin/base').base({ language: 'clientReport' }), require('common/mixin/base').base({ reuse: 'reuse' })]

const computed = {
  name() {
    return this.language.downloadName
  },
  tableHead() {
    return this.language.tableHead
  },
  downLoadTran() {
    return {
      ENABLE: this.language.enableMapper,
      loadText: this.language.loadText,
    }
  },
  jsonExcelAjax() {
    return {
      url: URL_CLIENT_REPORT,
      ajaxType: 'get',
      getKey: ['data', 'data', 'data'],
      ajaxPar: {
        pageSize: -1,
        pageNum: 0,
      },
    }
  },
}

const created = function () {
  this.ajaxHandle()
}

const methods = {
  ajaxHandle() {
    this.loading = true
    this.$http
      .get(URL_CLIENT_REPORT, {
        params: { pageNum: this.page.active, pageSize: this.selPage.limit },
      })
      .then((res) => {
        if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
          this.page.pageLeng = res.data.data.count
          this.tbodyData = res.data.data.data
          this.tbodyData.forEach((v) => {
            v.enable = [0, 1].includes(v.ENABLE) ? this.language.enableMapper[v.ENABLE] : ''
          })
        } else {
          this.tbodyData = []
          this.page.pageLeng = 0
        }
        this.loading = false
      })
      .catch((e) => {
        alert(this.reuse.serverError)
      })
  },
}

const components = {
  customTable,
}

export default {
  data,
  mixins,
  computed,
  created,
  methods,
  components,
}
</script>


// WEBPACK FOOTER //
// src/views/report/client-report.vue